import { useQuery } from "@tanstack/react-query";
import { axios } from "./axios";
import { env } from "../utils/env";
import { useNavigate } from "react-router-dom";
import { ROUTE } from "../routes";
import { Currency } from "../types/Individual";


const fetch = () =>
  axios.get<Currency[]>(`${env.verifyServiceUrl}common/currency_list/`);

export const useCurrency = () => {
  const navigate = useNavigate();
  return useQuery(["currency"], fetch, {retry: false,
    onError: (err: any) => {
      if(err.request.status === 500 || err.request.status === 503) {
        navigate(ROUTE.SERVER_ERROR);
      }
      if(err.request.status === 401) {
        navigate(ROUTE.LOGOUT);
      }
    }
  });
};
